<template>
  <Modal v-model="show" :title="'合同信息编辑'" :mask-closable="false" :closable='false' width="750">
    <Form :model="form" ref="form" :rules="rules" :label-width="120" inline>
      <FormItem label="签订方式:" prop="signingMode">
        <RadioGroup v-model="form.signingMode" style="width: 400px">
          <Radio :label="item.value" v-for="(item,index) in signingModeData" :key="index"><span>{{item.name}}</span></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="合同签订周期:" prop="signingCycle">
        <RadioGroup v-model="form.signingCycle" style="width: 400px">
          <Radio :label="item.value" v-for="(item,index) in signingCycleData" :key="index"><span>{{item.name}}</span></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="付款方式:" prop="payType">
        <RadioGroup v-model="form.payType" style="width: 120px">
          <Radio :label="item.value" v-for="(item,index) in payTypeData" :key="index"><span>{{item.name}}</span></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="承兑方式:" prop="honourType" v-if="form.payType==this.$constDefinition['承兑']">
        <RadioGroup v-model="form.honourType" style="width: 200px">
          <Radio :label="item.value" v-for="(item,index) in honourTypeData" :key="index"><span>{{item.name}}</span></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="联系人:" prop="contactsIdList">
        <Select v-model="form.contactsIdList" multiple style="width:465px">
          <Option v-for="item in contactsData" :value="item.value" :key="item.value">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="报价有效期:" prop="accountPeriod">
        <RadioGroup v-model="form.accountPeriod" style="width: 400px">
          <Radio :label="item.value" v-for="(item,index) in accountPeriodData" :key="index"><span>{{item.name}}</span></Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="质保条款/质保期限:" prop="warrantyTerms">
        <Input v-model="form.warrantyTerms" type="textarea" placeholder="请输入" style="width: 465px"></Input>
      </FormItem>
	  
	  
	  <FormItem label="文件模板类型:" prop="fileTemplateType">
	    <RadioGroup v-model="form.fileTemplateType" style="width: 300px">
	      <Radio :label="item.value" v-for="(item,index) in fileTemplateTypeData" :key="index"><span>{{item.name}}</span></Radio>
	    </RadioGroup>
	  </FormItem>
      <Row  v-if="form.fileTemplateType==this.$constDefinition['客户合同修改意见']">
        <Col span="8">
        <FormItem label="客户合同:" prop="客户合同_Files">
          <Upload ref="upload" multiple type="drag" :show-upload-list="false" style="width: 90px" :accept="accept" :data="uploadDataKHHT" :format='format' :on-success="handleSuccess1" :on-format-error="handleFormatError1"
            :action="$constDefinition.baseUrl+'/File/UploadByCustomer'">
            <div style="padding: 10px 0">
              <Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
              <p>上传文件</p>
            </div>
          </Upload>
        </FormItem>
        </Col>
        <Col span="14">
        <!-- 文件列表 -->
        <div class="fileList" v-if="form.客户合同_Files.length>0">
          <template v-for="(img, img_i) in form.客户合同_Files">
            <span :key="img_i" class="img_wrap">
              <span class="pos">
                <img class="img" :src="$constDefinition.baseUrl+ img.url" width="85px" height="85px" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" v-if="!isDisable" @click="handleRemove1(img_i,img.fileGuids)" type="ios-trash-outline" />
                  <!-- <Icon size="26" class="ico" color="#ffffff" @click="handleRemove1(img_i,img.fileGuids)" type="ios-trash-outline" /> -->
                  <Icon size="26" class="ico" color="#ffffff" @click="handleDownload(img.fileGuids,img.fileName,'客户合同')" type="md-arrow-down" />
                </i>
              </span>
              <span class="filename" :title="img.fileName">{{img.fileName}}</span>
            </span>
          </template>
        </div>
        </Col>
      </Row>

      <FormItem label="客户合同修改意见:" prop="contractOpinion"  v-if="form.fileTemplateType==this.$constDefinition['客户合同修改意见']">
        <Input v-model="form.contractOpinion" type="textarea" :maxlength="200" placeholder="请输入" style="width: 465px"></Input>
      </FormItem>
      <Row  v-if="form.fileTemplateType==this.$constDefinition['年度协议']">
        <Col span="8">
        <FormItem label="年度协议:" prop="年度协议_Files" >
          <Upload ref="upload" :show-upload-list="false" multiple type="drag" style="width: 90px" :accept="accept" :data="uploadDataNDXY" :format='format' :on-success="handleSuccess2" :on-format-error="handleFormatError2"
            :action="$constDefinition.baseUrl+'/File/UploadByCustomer'" >
            <div style="padding: 10px 0">
              <Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
              <p>上传文件</p>
            </div>
          </Upload>
        </FormItem>
        </Col>
        <Col span="14">
        <div class="fileList" v-if="form.年度协议_Files.length>0">
          <!-- <Divider plain orientation="left">已上传模板</Divider> -->
          <template v-for="(img, img_i) in form.年度协议_Files">
            <span :key="img_i" class="img_wrap">
              <span class="pos">
                <img class="img" :src="$constDefinition.baseUrl+ img.url" width="85px" height="85px" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" v-if="!isDisable" @click="handleRemove2(img_i,img.fileGuids)" type="ios-trash-outline" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleDownload(img.fileGuids,img.fileName,'年度协议')" type="md-arrow-down" />

                </i>
              </span>
              <span class="filename" :title="img.fileName">{{img.fileName}}</span>
            </span>
          </template>
        </div>
        </Col>
      </Row>

      <!-- 文件列表 -->

      <FormItem label="年度协议修改意见:" prop="annualAgreementOpinion" v-if="form.fileTemplateType==this.$constDefinition['年度协议']">
        <Input v-model="form.annualAgreementOpinion" type="textarea" :maxlength="200" placeholder="请输入" style="width: 465px"></Input>
      </FormItem>
    </Form>
    <Spin size="large" fix v-show="spinShow"></Spin>
    <div slot="footer">
      <Button @click="close()" class="close-btn">关闭</Button>
      <Button @click="submit()" type="primary" :disabled="spinShow" class="close-btn" v-if="!isDisable">提交</Button>
    </div>
  </Modal>
</template>
<script>
import { Col } from 'view-design'
import Util from '../../../lib/util'

export default {
  name: 'CreateContract',
  props: {
    show: Boolean, //弹窗 窗口显示
    customerId: Number,
    quotationId: Number,
	isDetail:Boolean
  },
  data() {
    return {
      accept: 'image/*',
      format: ['jpg', 'pdf', 'png', 'jpeg'],
      form: {
        signingMode: null,
        signingCycle: null,
        payType: null,
		fileTemplateType:null,
        honourType: null,
        accountPeriod: null,
        客户合同_Files: [],
        年度协议_Files: [],
        contactsIdList: [],
        warrantyTerms: '',
        annualAgreementOpinion: '',
        contractOpinion: '',
        customerId: this.customerId,
        id: this.quotationId,
      },
      rules: {
        signingMode: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'number' },
        ],
        contactsIdList: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'array' },
        ],
        signingCycle: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'number' },
        ],
        payType: [{ required: true, message: '请选择', trigger: 'blur,change', type: 'number' }],
        fileTemplateType: [{ required: true, message: '请选择', trigger: 'blur,change', type: 'number' }],
        accountPeriod: [
          { required: true, message: '请选择', trigger: 'blur,change', type: 'number' },
        ],
        biddingProcess: [
          { required: false, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        bidTemplate: [
          { required: false, message: '请输入', trigger: 'blur,change', type: 'string' },
        ],
        客户合同_Files: [
          { required: false, message: '请上传文件', trigger: 'blur,change', type: 'array' },
        ],
        客户合同_Files: [
          { required: false, message: '请上传文件', trigger: 'blur,change', type: 'array' },
        ],
      },
      uploadDataKHHT: {
        id: this.customerId,
        type: this.$constDefinition['合同信息_客户合同'],
      },
      uploadDataNDXY: {
        id: this.customerId,
        type: this.$constDefinition['合同信息_年度协议'],
      },
      accountPeriodData: [], //
      payTypeData: [], //
      fileTemplateTypeData: [], //
      honourTypeData: [], //
      signingCycleData: [], //
      signingModeData: [], //
      contactsData: [], //list
      spinShow: false,
	  isDisable:false,
    }
  },
  mounted() {
    if (this.customerId) {
      this.spinShow = true
      this.getUser()
    }
    if (this.quotationId) {
      this.getDetail()
    }
	console.log(this.isDetail,"show")
	if(this.isDetail){
		this.isDisable=this.isDetail
	}
  },
  methods: {
    // 关闭弹窗
    close(refresh) {
      this.form = {
        signingMode: null,
        signingCycle: null,
        payType: null,
		fileTemplateType:null,
        honourType: null,
        accountPeriod: null,
        客户合同_Files: [],
        年度协议_Files: [],
        contactsIdList: [],
        warrantyTerms: '',
        annualAgreementOpinion: '',
        contractOpinion: '',
        customerId: this.customerId,
        id: 0,
      }
      this.$refs['form'].resetFields()
      this.$emit('close', refresh)
    },
    //   提交记录
    submit() {
      let _this = this
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          let files = []
          this.spinShow = true
          var url = ''
          let files1 = []
          if (_this.form.客户合同_Files.length > 0) {
            _this.form.客户合同_Files.map((file) => {
              files1.push(file.fileGuids)
            })
            _this.form.contractTemplateGuidList = files1
          }
          let files2 = []
          if (_this.form.年度协议_Files.length > 0) {
            _this.form.年度协议_Files.map((file) => {
              files2.push(file.fileGuids)
            })
            _this.form.annualAgreementGuidList = files2
          }

          if (this.form.id != null && this.form.id != 0) {
            url = '/api/services/app/CustomerContractApiService/Update'
            let { data } = await this.$Ajax.put(url, this.form)
            if (data.success) {
              this.$Message.success({
                content: '编辑成功',
              })
              _this.close(true)
            }
          } else {
            url = '/api/services/app/CustomerContractApiService/Create'
            let { data } = await this.$Ajax.post(url, this.form)
            if (data.success) {
              this.$Message.success({
                content: '新建成功',
              })
              _this.close(true)
            }
          }
          this.spinShow = false
        }
      })
    },
    //   获取下拉框数据
    async getUser() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerContractApiService/GetContractMgrInitData?customerId=${this.customerId}`
      )
      this.contactsData = data.result.contactsData
      this.signingModeData = data.result.signingModeData
      this.signingCycleData = data.result.signingCycleData
      this.accountPeriodData = data.result.accountPeriodData
      this.payTypeData = data.result.payTypeData
      this.fileTemplateTypeData = data.result.fileTemplateTypeData
      this.honourTypeData = data.result.honourTypeData
      this.spinShow = false
    },
    async getDetail() {
      const { data } = await this.$Ajax.get(
        `/api/services/app/CustomerContractApiService/GetDetailById?id=${this.quotationId}`
      )
      this.form = data.result
      this.spinShow = false
    },
    //文件上传成功
    handleSuccess1(e) {
      this.form.客户合同_Files.push(e.result)
      this.$refs.form.validateField('客户合同_Files')
      // this.$refs.upload.clearFiles()
    },
    //文件上传成功
    handleSuccess2(e) {
      this.form.年度协议_Files.push(e.result)
      this.$refs.form.validateField('年度协议_Files')
      // this.$refs.upload.clearFiles()
    },
    //文件格式错误
    handleFormatError1(file) {
      this.$Notice.warning({
        title: '文件格式错误',
        // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    //文件格式错误
    handleFormatError2(file) {
      this.$Notice.warning({
        title: '文件格式错误',
        // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    //移除文件
    async handleRemove1(index, guid) {
      try {
        const { data } = await this.$Ajax.delete(
          `/api/services/app/ComFile/DeleteFileByGuid?guid=${guid}`
        )
        this.form.客户合同_Files.splice(index, 1)
      } catch (error) {
        this.$Message.error({
          content: '删除失败',
        })
      }
    },
    //移除文件
    async handleRemove2(index, guid) {
      try {
        const { data } = await this.$Ajax.delete(
          `/api/services/app/ComFile/DeleteFileByGuid?guid=${guid}`
        )
        this.form.年度协议_Files.splice(index, 1)
      } catch (error) {
        this.$Message.error({
          content: '删除失败',
        })
      }
    },
    handleDownload(id, name, type) {
      let fileExtension,
        fileParts = null
      if (name.indexOf('.') > -1) {
        fileParts = name.split('.')
        fileExtension = '.' + fileParts[fileParts.length - 1]
      }
      this.$downLoad(`/files/downloadFile_Path/${id}`, type, fileExtension)
    },
  },
}
</script>
<style lang="less" scoped>
.fileList {
  display: flex;
  flex-wrap: wrap;
  .filename {
    width: 80px;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    line-clamp: 2;
    -webkit-box-orient: vertical; //盒子中内容竖直排列
  }
}
.img {
  margin-right: 10px;
}
.pos {
  position: relative;
}
.pos:hover .img_magnify {
  display: inline-block;
}
.ico {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-100%, -50%);
  cursor: pointer;
}
.img_magnify {
  display: none;
  background: rgba(0, 0, 0, 0.459);
  position: absolute;
  z-index: 1;
  width: 85px;
  height: 85px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
}
.img_wrap {
  display: flex;
  flex-direction: column;
  padding: 0px 0px;
}
/deep/.ivu-input[type='radio'] {
  width: 20px !important;
}
</style>